@if (loading()) {
  <p class="cg-form-help">Loading attachments…</p>
} @else if (attachments().length === 0) {
  <app-admin-empty-state icon="image" title="No attachments" description="No files were uploaded with this request." />
} @else {
  <div class="fr-attachments">
    @for (item of attachments(); track item._id) {
      <div class="fr-attachments__card">
        @if (isImage(item.mimeType)) {
          <button type="button" class="fr-attachments__thumb" (click)="openPreview(item)">
            <img [src]="item.fileUrl" [alt]="item.fileName" />
          </button>
        } @else {
          <div class="fr-attachments__pdf">PDF</div>
        }
        <p class="fr-attachments__name">{{ item.fileName }}</p>
        <div class="fr-attachments__actions">
          @if (isImage(item.mimeType)) {
            <button type="button" class="fr-attachments__link" (click)="openPreview(item)">Preview</button>
          }
          <a class="fr-attachments__link" [href]="item.fileUrl" target="_blank" rel="noopener noreferrer" download>Download</a>
        </div>
      </div>
    }
  </div>
}

@if (previewUrl()) {
  <app-admin-modal [title]="previewTitle()" size="lg" (closed)="closePreview()">
    <img class="fr-attachments__preview-img" [src]="previewUrl()!" [alt]="previewTitle()" />
  </app-admin-modal>
}
